import React, { useState, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useSelector, shallowEqual } from 'react-redux';
import { Menu, MenuItem } from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';
import {
  StyledBreadcrumbs,
  MobileBreadcrumbContainer,
  StyledLink,
  StyledExpandIcon,
  StyledTypography
} from './styles';

const AppBreadcrumb = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);
  const breadcrumbs = useSelector(s => s.breadcrumbs, shallowEqual);

  const bcColor = theme.wl?.breadcrumbs?.color;
  const breadcrumbColor = bcColor ? `#${bcColor}` : theme.secondary.primary.main;
  const bgColor = theme.wl?.header?.['background-color'];
  const backgroundColor = bgColor ? `#${bgColor}` : theme.palette.primary.main;
  const lastBcColor = theme.wl?.breadcrumbs?.['last-breadcrumb-color'];
  const lastBreadcrumbColor = lastBcColor ? `#${lastBcColor}` : theme.palette.getContrastText(backgroundColor);

  useEffect(() => {
    setAnchorEl(null);
  }, [isMobile]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <StyledBreadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="Breadcrumb"
        breadcrumbColor={breadcrumbColor}
        lastBreadcrumbColor={lastBreadcrumbColor}
      >
        {isMobile ? (
          breadcrumbs.length > 1 ? (
            <ButtonBase onClick={handleClick}>
              <Tooltip title="Breadcrumbs">
                <MobileBreadcrumbContainer>
                  <StyledTypography>
                    {breadcrumbs[breadcrumbs.length - 1]?.label ?? ''}
                  </StyledTypography>
                  <StyledExpandIcon lastBreadcrumbColor={lastBreadcrumbColor} />
                </MobileBreadcrumbContainer>
              </Tooltip>
            </ButtonBase>
          ) : (
            <StyledTypography>
              {breadcrumbs[breadcrumbs.length - 1]?.label ?? ''}
            </StyledTypography>
          )
        ) : (
          breadcrumbs.map((bc, index) => {
            const last = index === breadcrumbs.length - 1;
            const key = bc.path + index;

            return last ? (
              <StyledTypography key={key}>
                {bc.label}
              </StyledTypography>
            ) : (
              <StyledLink
                component={RouterLink}
                to={bc.path}
                key={key}
                breadcrumbColor={breadcrumbColor}
              >
                { bc.label}
              </StyledLink>
            );
          })
        )}
      </StyledBreadcrumbs>
      {isMobile && breadcrumbs.length > 1 && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {breadcrumbs.slice(0, -1).map(bc => (
            <MenuItem
              key={bc.path}
              component={RouterLink}
              to={bc.path}
              onClick={handleClose}
              onAuxClick={handleClose}
            >
              {bc.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default AppBreadcrumb;
